import { createContext, useContext, useMemo, useState, useEffect, useCallback } from "react";

const DR_KEY = "dr_count";

function readDrCount() {
  try {
    const raw = localStorage.getItem(DR_KEY);
    return raw == null || raw === "" ? 0 : Number(raw) || 0;
  } catch {
    return 0;
  }
}

const UserContext = createContext(null);

/**
 * User-scoped UI counters (e.g. daily requests) initialized before Dashboard renders to avoid TDZ issues.
 */
export function UserProvider({ children }) {
  const [dr, setDr] = useState(() => readDrCount());

  const refreshDr = useCallback(() => {
    setDr(readDrCount());
  }, []);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === DR_KEY || e.key === null) setDr(readDrCount());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const value = useMemo(() => ({ dr, setDr, refreshDr }), [dr, refreshDr]);

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export function useUser() {
  const ctx = useContext(UserContext);
  if (!ctx) throw new Error("useUser must be used within UserProvider");
  return ctx;
}
